import { FormItemBase } from './form-item-base';
import { FormItemControlService } from '../services/form-item-control.service';

export class FormItemMultiLineTextBox extends FormItemBase<string> {
  controlType = 'multilinetextbox';
  type: string;
  heightHint: number;
  showCopy: boolean;
  showValidate: boolean;
  icon: string;
  alertLevel: string;
  bAlertUser: boolean;
  alertMessage: string;
  formItemControlService: FormItemControlService;
  bWorksheetErrorsExists: boolean;
  bWorksheetWarningsExist: boolean;

  constructor(options: {
    itemType?: string,
    value?: string,
    key?: string,
    label?: string,
    shortlabel?: string,
    altlabel?: string,
    comment?: string,
    required?: boolean,
    order?: number,
    controlType?: string,
    depth?: number,
    isVisible?: boolean,
    isEnabled?: boolean,
    isReadOnly?: boolean,
    invalidValue?: boolean,
    useAltText?: boolean,
    heightHint?: string,
    showValidate?: boolean,
    showCopy?: boolean,
    isTooltipDefined?: boolean,
    errorHint?: string,
    alertLevel?: string,
    bWorksheetErrorsExist?: boolean,
    bWorksheetWarningsExist?: boolean,
    formItemControlService?: FormItemControlService
  } = {}) {
    super(options);
    const key = 'type';

    this.type = options[key] || '';

    this.heightHint = 100;
    this.showCopy = options.showCopy;
    this.showValidate = options.showValidate;
    this.isReadOnly = options.isReadOnly;
    this.alertLevel = options.alertLevel || '';
    this.bAlertUser = false;
    this.alertMessage = '';
    this.formItemControlService = options.formItemControlService || null;
    this.bWorksheetErrorsExists = options.bWorksheetErrorsExist || false;
    this.bWorksheetWarningsExist = options.bWorksheetWarningsExist || false;

    // if (this.showCopy) {
    //   console.log('Show Copy true');
    // }

    this.labelClass = 'dx-field-label field-label-override form-item-multiline-textbox-label form-item-depth-' + this.depth.toString();

    this.heightHint = 300; // normal

    if (options.heightHint != null) {
      if (options.heightHint === 'x-small') {
        this.heightHint = 80;
      } else if (options.heightHint === 'smaller') {
        this.heightHint = 150;
      } else if (options.heightHint === 'larger') {
        this.heightHint = 650;
      } else if (options.heightHint === 'x-large') {
        this.heightHint = 800;
      }
    }

    this.icon = '';
    this.alertLevel = options.alertLevel;

    if (this.formItemControlService != null) {
      this.formItemControlService.updateFormItemButton(this, this.bWorksheetErrorsExists, this.bWorksheetWarningsExist);
    }

    // if (options.fgColorHint != null)
    // {
    //   if (options.fgColorHint === 'black' ||
    //       options.fgColorHint === 'red' ||
    //       options.fgColorHint === 'green' ||
    //       options.fgColorHint === 'blue' ||
    //       options.fgColorHint === 'magenta' ||
    //       options.fgColorHint === 'cyan' ||
    //       options.fgColorHint === 'orange') {
    //         this.fgColorHint = options.fgColorHint;
    //       } else {
    //         this.fgColorHint = 'black';
    //       }
    // } else
    // {
    //   this.fgColorHint = 'black';
    // }
  }
}
